import React from 'react';

const MarkerIcon = () => (
  <svg
    height="57px"
    width="44px"
    version="1.1"
    viewBox="0 0 44 57"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Unife---Grafica-v.2"
      fill="none"
      fillRule="evenodd"
      stroke="none"
      strokeWidth="1"
    >
      <g
        id="Unife---Programmi-internazionali"
        fillRule="nonzero"
        transform="translate(-319.000000, -1007.000000)"
      >
        <g id="titolo+desc+testo" transform="translate(-72.000000, 252.000000)">
          <g id="mappa-e-cerca" transform="translate(0.000000, 470.000000)">
            <g id="pin-s" transform="translate(391.000000, 203.000000)">
              <g id="pin-copy-9" transform="translate(0.000000, 82.000000)">
                <rect
                  height="37"
                  id="Rectangle"
                  width="42"
                  fill="#FFFFFF"
                  x="0"
                  y="2"
                />
                <path
                  id="Shape"
                  d="M33,28.4994255 C33,29.325233 28.5221597,30 22.9970721,30 C17.474255,30 13,29.3251053 13,28.4994255 C13,27.6711921 17.474255,27 22.9970721,27 C28.5245499,27 33,27.6711921 33,28.4994255 Z M22.9976612,19 C14.167916,19 12,22.2469154 12,22.2469154 L12,23 C12.7441079,22.2049712 15.4193703,20.1209034 22.9976612,20.1209034 C30.575952,20.1209034 33.2558921,22.2049712 34,22.998805 L34,22.2481104 C34,22.2469154 31.8286057,19 22.9976612,19 Z M44,0 L44,44.1943332 L30.1595518,44.1943332 L22,57 L13.8439803,44.1943332 L0,44.1943332 L0,0 L44,0 Z M39,28 C37.8328365,28.532592 37.3754002,28 37.3754002,28 L37,34 C38.0959479,31.9999567 39,32.7533479 39,32.7533479 L39,28 Z M38.4885389,26.7667854 L38.4885389,23.114775 L42,21.1705868 L22.9982328,11 L4,21.1705868 L11.5755031,25.5816563 L11.5755031,28.3815268 L11.6457031,28.3517214 C11.5623406,28.4627586 11.5111532,28.5701311 11.5111532,28.6859322 C11.5111532,29.9616989 16.650376,31 22.9994516,31 C29.3485271,31 34.4948187,29.9604774 34.4948187,28.6859322 C34.4948187,28.5701311 34.4388781,28.4627586 34.3625844,28.3517214 L34.42925,28.3815268 L34.42925,25.5744492 L37.7323049,23.5371803 L37.7323049,26.7666632 C37.371555,26.9134912 37.1179333,27.2738428 37.1179333,27.6891632 C37.1179333,28.2381191 37.5620456,28.6844664 38.1109703,28.6844664 C38.6623326,28.6844664 39.1040074,28.2393406 39.1040074,27.6891632 C39.1041293,27.2739649 38.852945,26.9134912 38.4885389,26.7667854 Z"
                  fill="#213E72"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default MarkerIcon;
